import { useCallback, useEffect, useRef } from 'react';
import { useKeysDown } from 'shared/hooks/use-keys-down';
import { ID } from 'shared/types/id';

import { TreeItem } from './types';

export type Options = {
  onCollapse?: (ids: ID[]) => void;
  onEscape?: () => void;
};

export const useKeyboardShortcuts = (
  items: Record<ID, TreeItem>,
  { onCollapse, onEscape }: Options,
) => {
  const itemsRef = useRef(items);

  useEffect(() => {
    itemsRef.current = items;
  }, [items]);

  const expandAll = useCallback(() => onCollapse?.([]), [onCollapse]);

  const collapseAll = useCallback(() => {
    onCollapse?.(Object.keys(itemsRef.current));
  }, [onCollapse]);

  const handleEscape = useCallback(() => onEscape?.(), [onEscape]);

  useKeysDown(
    [
      ['ControlLeft', 'ShiftLeft', 'KeyE'],
      ['ControlRight', 'ShiftLeft', 'KeyE'],
      ['ControlLeft', 'ShiftRight', 'KeyE'],
      ['ControlRight', 'ShiftRight', 'KeyE'],
    ],
    expandAll,
  );

  useKeysDown(
    [
      ['ControlLeft', 'ShiftLeft', 'KeyC'],
      ['ControlLeft', 'ShiftRight', 'KeyC'],
      ['ControlRight', 'ShiftLeft', 'KeyC'],
      ['ControlRight', 'ShiftRight', 'KeyC'],
    ],
    collapseAll,
  );

  useKeysDown(['Escape'], handleEscape);
};
